import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";
import { NEWS_CATEGORY_LABEL } from "@/mocks/news";

interface NewsListItemProps {
  item: NewsItem;
}

export default function NewsListItem({ item }: NewsListItemProps) {
  return (
    <Link
      to={`/news/detail/${item.id}`}
      className="group flex gap-3 md:gap-4 p-3 md:p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-primary-50/40 transition-colors cursor-pointer"
    >
      <div className="w-28 h-20 md:w-44 md:h-28 shrink-0 rounded-md overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 配图`}
          title={`${item.title} - 影视影院资讯详情`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex-1 min-w-0 flex flex-col">
        <div className="flex items-center gap-2 mb-1.5">
          <span className="px-2 py-0.5 rounded bg-accent-100 text-accent-800 text-xs font-label">
            {NEWS_CATEGORY_LABEL[item.category]}
          </span>
          <span className="text-xs text-foreground-400">{item.date}</span>
        </div>
        <h3 className="font-heading font-bold text-sm md:text-base text-foreground-950 line-clamp-2 group-hover:text-primary-700 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1.5 text-xs md:text-sm text-foreground-500 line-clamp-2 leading-relaxed">
          {item.summary}
        </p>
        <span className="mt-auto pt-2 text-xs text-foreground-400 hidden sm:block">
          {item.author}
        </span>
      </div>
    </Link>
  );
}